import EventEmitter from "eventemitter3";
import React, { useContext, useRef } from "react";
import { VelavuAsset, VelavuDevice } from "velavu-js-api";
import { ObjectUpdate } from "./object-update";

export interface EmitterDetails {
	asset: [ObjectUpdate<VelavuAsset>];
	device: [ObjectUpdate<VelavuDevice>];
}

interface EmitterContextType {
	emitter: EventEmitter<EmitterDetails>;
}

const EmitterContext = React.createContext<EmitterContextType>({
	get emitter(): EventEmitter<EmitterDetails> {
		throw new Error("EmitterContext not initialized");
	},
});
export default EmitterContext;

export function EventEmitterProvider(props: { children?: React.ReactNode }) {
	const emitter = useRef(new EventEmitter<EmitterDetails>()).current;

	return (
		<EmitterContext.Provider
			value={{
				emitter,
			}}
		>
			{props.children}
		</EmitterContext.Provider>
	);
}

export function useGlobalEmitter(): EventEmitter<EmitterDetails> {
	return useContext(EmitterContext).emitter;
}
